import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import './App.css'
import App from './App';
import './locales/index'
import { Provider } from 'react-redux';
import { persistor, store } from './store';
import { PersistGate } from 'redux-persist/integration/react'
import * as Sentry from '@sentry/react';
import { PostHogProvider } from 'posthog-js/react'
import posthog from "./posthog"

//Intergrate sentry
if (process.env.NODE_ENV === 'production') {
  // Integrate Sentry only in production
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_URI,
    integrations: [Sentry.browserTracingIntegration({})],
    sendDefaultPii: true,
    tracesSampleRate: 1.0,
    environment: process.env.NODE_ENV,
  });
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);



root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <PostHogProvider client={posthog} >
        <App />
      </PostHogProvider>
    </PersistGate>

  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
